import { render, staticRenderFns } from "./wishList.vue?vue&type=template&id=2d38f879&"
import script from "./wishList.vue?vue&type=script&lang=js&"
export * from "./wishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports